import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

export type WithdrawalModalMode = 'success' | 'error';

export type WithdrawalModalAction = 'clear' | 'consult' | 'retry' | 'dismiss';

export interface WithdrawalResultModalViewModel {
  mode: WithdrawalModalMode;
  heading: string;
  icon: string;
  iconTone: 'success' | 'warning' | 'danger';
  bodyText: string;
  operationCode?: string;
}

const CREDIT_LIMIT_MESSAGE = 'Ultrapassou o limite de créditos disponível para a operação';

const DEFAULT_ERROR_MESSAGE =
  'Não foi possível concluir a aposentadoria. Verifique os dados e tente novamente ou entre em contato com o suporte.';

const CREDIT_LIMIT_BODY =
  'A operação ultrapassou o total de créditos disponíveis para essa ação';

const SUCCESS_BODY = 'Aposentadoria dos créditos foi realizada com sucesso.';

export function buildWithdrawalResultModalViewModel(
  data: CarbonOperation | string,
  titleModal = '',
): WithdrawalResultModalViewModel {
  if (typeof data === 'string') {
    if (data === CREDIT_LIMIT_MESSAGE || titleModal === CREDIT_LIMIT_MESSAGE) {
      return {
        mode: 'error',
        heading: 'Operação rejeitada',
        icon: 'warning',
        iconTone: 'warning',
        bodyText: CREDIT_LIMIT_BODY,
      };
    }

    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: data || DEFAULT_ERROR_MESSAGE,
    };
  }

  if (data.statusCode === 'OP_REJEITADA') {
    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: DEFAULT_ERROR_MESSAGE,
    };
  }

  const isError =
    (data.statusCode == null && !data.operationCode)
    || (data.statusCode != null && Number(data.statusCode) === 0);

  if (isError) {
    return {
      mode: 'error',
      heading: 'Erro!',
      icon: 'error',
      iconTone: 'danger',
      bodyText: DEFAULT_ERROR_MESSAGE,
    };
  }

  return {
    mode: 'success',
    heading: 'Sucesso!',
    icon: 'check_circle',
    iconTone: 'success',
    bodyText: SUCCESS_BODY,
    operationCode: data.operationCode,
  };
}
